var Actions;
(function (Actions) {
    Actions["GET_DEFINE_CURRENT_VERSION_LIST"] = "getDefineCurrentVersionList";
    Actions["GET_DEFINE_CURRENT_VERSION_LIST_ID_DESC"] = "getDefineCurrentVersionListIdDesc";
    Actions["CREATE_DEFINE_CURRENT_VERSION_LIST"] = "createDefineCurrentVersionList";
    Actions["UPDATE_DEFINE_CURRENT_VERSION_LIST"] = "updateDefineCurrentVersionList";
    Actions["GET_DEFINE_CURRENT_VERSION_LIST_FILTER"] = "getDefineCurrentVersionListFilter";
    Actions["GET_DEFINE_CURRENT_VERSION_DATA"] = "getDefineCurrentVersionData";
    Actions["UPDATE_SELECTED_DEFINE_CURRENT_VERSION_ID"] = "updateSelectedDefineCurrentVersionId";
    Actions["UPDATE_SELECTED_DEFINE_CURRENT_VERSION_DESC"] = "updateSelectedDefineCurrentVersionDesc";
    Actions["UPDATE_SELECTED_DEFINE_CURRENT_VERSION_YEAR"] = "updateSelectedDefineCurrentVersionYear";
    Actions["UPDATE_DEFINE_CURRENT_VERSION_SIZE"] = "updateDefineCurrentVersionSize";
    Actions["RESET_DEFINE_CURRENT_VERSION_FILTER"] = "resetDefineCurrentVersionFilter";
    Actions["GET_DEFINE_CURRENT_VERSION_LOOKUP"] = "getDefineCurrentVersionLookup";
    Actions["DOWNLOAD_DEFINE_CURRENT_VERSION"] = "downloadDefineCurrentVersion";
    Actions["UPDATE_DEFINE_CURRENT_VERSION_BUDGET"] = "updateDefineCurrentVersionBudget";
    Actions["UPDATE_DEFINE_CURRENT_VERSION_YEAR"] = "updateDefineCurrentVersionYear";
    Actions["UPDATE_DEFINE_CURRENT_VERSION_VERSION"] = "updateDefineCurrentVersionVersion";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_DEFINE_CURRENT_VERSION_LOAD"] = "setDefineCurrentVersionWasFirstLoad";
    Mutations["SET_DEFINE_CURRENT_VERSION_LOADING"] = "setDefineCurrentVersionLoading";
    Mutations["SET_DEFINE_CURRENT_VERSION_HANDLE_PAGE"] = "setDefineCurrentVersionHandlePage";
    Mutations["SET_DEFINE_CURRENT_VERSION_LIST"] = "setDefineCurrentVersionList";
    Mutations["SET_DEFINE_CURRENT_VERSION_LIST_ID"] = "setDefineCurrentVersionListId";
    Mutations["SET_DEFINE_CURRENT_VERSION_LIST_DESC"] = "setDefineCurrentVersionListDesc";
    Mutations["SET_DEFINE_CURRENT_VERSION_LIST_YEAR"] = "setDefineCurrentVersionListYear";
    Mutations["SET_DEFINE_CURRENT_VERSION_PAGE"] = "setDefineCurrentVersionPage";
    Mutations["SET_DEFINE_CURRENT_VERSION_LOAD_PAGE"] = "setDefineCurrentVersionLoadPage";
    Mutations["SET_SELECTED_DEFINE_CURRENT_VERSION_ID"] = "setSelectedDefineCurrentVersionId";
    Mutations["SET_SELECTED_DEFINE_CURRENT_VERSION_DESC"] = "setSelectedDefineCurrentVersionDesc";
    Mutations["SET_SELECTED_DEFINE_CURRENT_VERSION_YEAR"] = "setSelectedDefineCurrentVersionYear";
    Mutations["SET_DEFINE_CURRENT_VERSION_STATUS"] = "setDefineCurrentVersionStatus";
    Mutations["SET_DEFINE_CURRENT_VERSION_SIZE"] = "setDefineCurrentVersionSize";
    Mutations["SET_DEFINE_CURRENT_VERSION_USE_FILTER"] = "setDefineCurrentVersionUseFilter";
    Mutations["SET_DEFINE_CURRENT_VERSION_LOOKUP"] = "setDefineCurrentVersionLookup";
    Mutations["SET_DEFINE_CURRENT_VERSION_DESC"] = "setDefineCurrentVersionSelectedDesc";
    Mutations["SET_DEFINE_CURRENT_VERSION_SEARCH_BY"] = "setDefineCurrentVersionSelectedSearchBy";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
